import { useMemo } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import { ProviderAccess } from '~/lib/constants/permissions.constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';

export type PortalAccess = { admin: boolean; maud: boolean; ops: boolean };

const usePortalAccess = (): PortalAccess => {
  const { access } = useGlobalContext();
  const { scriptsureTechOps: isScriptsureTechOpsEnabled } = useFlags<LDFlags>();

  const admin = access.includes(ProviderAccess.ADMIN_ACCESS_APP);
  const maud = access.includes(ProviderAccess.MAUD_ACCESS_APP);
  const ops =
    !!isScriptsureTechOpsEnabled &&
    access.includes(ProviderAccess.OPS_ACCESS_APP);

  return useMemo<PortalAccess>(
    () => ({ admin, maud, ops }),
    [admin, maud, ops],
  );
};

export default usePortalAccess;
